module.exports = __webpack_public_path__ + "images/otoliftac04c55f443d6c24575f500e0023214a.png";